
import debounce from 'lodash/debounce'
import 'components/catalog.tag'
import moment from 'moment'
riot.tag2('purchases-list', '  <catalog object="Purchase" search="true" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" add="{permission(add, &quot;purchases&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;purchases&quot;, &quot;0001&quot;)}" dblclick="{permission(purchaseOpen, &quot;purchases&quot;, &quot;1000&quot;)}" before-success="{getAggregation}" store="purchases-list" new-filter="true" allselect="true">\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <label class="control-label">От даты</label>\n            <datetime-picker class="form-control date-picker" data-name="date" data-sign="&gt;=" format="DD.MM.YYYY" value="{parent.startDate}"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">До даты</label>\n            <datetime-picker class="form-control date-picker" data-name="date" data-sign="&lt;=" format="DD.MM.YYYY" value="{parent.endDate}"></datetime-picker>\n          </div>\n        </div>\n      </div>\n    </yield>\n    <yield to="body">\n      <datatable-cell name="id"><a class="open-page-item" href="#purchases/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n      <datatable-cell name="provider" onclick="{handlers.copyText}">{row.provider}</datatable-cell>\n      <datatable-cell name="date" onclick="{handlers.copyText}">{row.date}</datatable-cell>\n      <datatable-cell name="commentary" onclick="{handlers.copyText}">{row.commentary}</datatable-cell>\n      <datatable-cell name="amount" onclick="{handlers.copyText}">{row.amount.toFixed(2)}</datatable-cell>\n      <datatable-cell name="amountPaid" onclick="{handlers.copyText}">{row.amountPaid}</datatable-cell>\n      <datatable-cell class="{bg-success: true, bg-danger: (row.credited &lt; 100), bg-warning: (row.credited &gt; 100)}" name="credited" onclick="{handlers.copyText}">{row.credited}%</datatable-cell>\n      <datatable-cell name="stockAmount" onclick="{handlers.copyText}">{(row.amount - row.amountPaid).toFixed(2)}</datatable-cell>\n    </yield>\n    <yield to="aggregation"><strong> Сумма:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalAmount || 0)}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong><br></yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Purchase';
self.idManager = app.config.idUser;
self.startDate = '';
self.endDate = '';

self.cols = [{ name: 'id', value: '#' }, { name: 'provider', value: 'Поставщик' }, { name: 'date', value: 'Дата' }, { name: 'commentary', value: 'Примечание' }, { name: 'amount', value: 'Сумма' }, { name: 'amountPaid', value: 'Оплачен' }, { name: 'credited', value: 'Заприходован' }, { name: 'stockAmount', value: 'Остаток суммы' }];

self.handlers = {
    copyText: function copyText(elem) {
        //copyToClipboard(elem.target)
    }
};

self.purchaseOpen = function (e) {
    riot.route('/purchases/' + e.item.row.id);
};

self.getAggregation = function (response, xhr) {
    self.totalAmount = parseFloat(response.totalAmount).toFixed(2);
    self.currTotal = response.currTotal;
};

self.add = function () {
    return riot.route('/purchases/new');
};

observable.on('purchases-reload', function () {
    self.tags.catalog.reload();
});

self.on('mount', function () {
    self.idManager = app.config.idUser;
    self.update();
});

function copyToClipboard(elem) {
    var target = {};
    // create hidden text element, if it doesn't already exist
    var targetId = "_hiddenCopyText_";
    var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
    var origSelectionStart, origSelectionEnd;
    if (isInput) {
        // can just use the original source element for the selection and copy
        target.assign(elem);
        origSelectionStart = target.selectionStart;
        origSelectionEnd = target.selectionEnd;
    } else {
        // must use a temporary form element for the selection and copy
        target = document.getElementById(targetId);
        if (!target) {
            var target = document.createElement("textarea");
            target.style.position = "absolute";
            target.style.left = "-9999px";
            target.style.top = "0";
            target.id = targetId;
            document.body.appendChild(target);
        }
        target.textContent = target.textContent.trim();
    }
    // select the content
    var currentFocus = document.activeElement;
    target.focus();
    target.setSelectionRange(0, target.value.length);

    // copy the selection
    var succeed;
    try {
        succeed = document.execCommand("copy");
    } catch (e) {
        succeed = false;
    }
    /*
    // restore original focus
    if (currentFocus && typeof currentFocus.focus === "function") {
        currentFocus.focus();
    }
         if (isInput) {
        // restore prior selection
        elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
        // clear temporary content
        target.textContent = "";
    }
    */
    return succeed;
}
});


// WEBPACK FOOTER //
// ./pages/purchases/purchases-list.tag